import { UserFileProcessingStatus } from '@/user_files/schemas/processing-status'

export type FileProcessingTone = 'success' | 'error' | 'in_progress' | 'neutral'

/** Terminal for polling: success or failure (not `PENDING` / `PROCESSING`). */
export function isTerminalProcessingStatus(status: string | null | undefined): boolean {
  return status === UserFileProcessingStatus.Completed || status === UserFileProcessingStatus.Failed
}

export function getProcessingStatusTone(status: string | null | undefined): FileProcessingTone {
  switch (status) {
    case UserFileProcessingStatus.Completed:
      return 'success'
    case UserFileProcessingStatus.Failed:
      return 'error'
    case UserFileProcessingStatus.Processing:
      return 'in_progress'
    default:
      return 'neutral'
  }
}

export function isSelectableProcessingStatus(status: string | null | undefined): boolean {
  return status === UserFileProcessingStatus.Completed
}
